import { useState, useRef, useEffect } from 'react';
import { Link, useNavigate  } from 'react-router-dom';
import imgretour from '../assets/images/back-512x512.png';
import '../styles/entree_sortie.css';

function Sortie() 
{
    const [code, setCode] = useState(['', '', '', '']);
    const [message, setMessage] = useState('');
    const inputRefs = useRef([]);
    const strCodeTiers = sessionStorage.getItem ("code:");
    const strLibelleGroupe = sessionStorage.getItem ("formation:");
    const strEtiquette = sessionStorage.getItem ("etiquette:");


    const serveur = "http://192.168.2.168:153/";
    //const serveur = "https://wsmobile.cnam-paysdelaloire.fr/";
    const navigate = useNavigate();

    const handleChange = (value, index) => {
        if (/^[0-9a-zA-Z]?$/.test(value)) {
            const newCode = [...code];
            newCode[index] = value;
            setCode(newCode);
            // Pass focus to next input
            if (value && index < 3) {
                inputRefs.current[index + 1].focus();
            }
        }
    };

    const handleSubmit = (e) => 
    {
        e.preventDefault();
        const strCode = code.join('');
        const strType = "Sortie";
        //console.log('Code saisi:', strCode);
        let fFormulaire = {strCode,strCodeTiers,strType,strLibelleGroupe};//strEtiquette};
        console.log('parametres:', fFormulaire);
        fetch(serveur + 'MobilePDL/Services/CodeMediatheque', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            "Accept": 'application/json' 
        },
            body: JSON.stringify(fFormulaire),
        })
        .then(res => res.json())
        .then(data => {
            const message = data.message;
            console.log('Réponse:', data);
            setMessage(message);

            // Si le retour est correct (à adapter selon ta structure de réponse)
            if (data.code == 1) 
            {
                // Démarrer le timer de 5 min = 300000 ms
                setTimeout(() => {
                    navigate('/Accueil');
                }, 5000);
            }
        })
        .catch(err => {
            console.error('Erreur:', err);
        });
    };

    return (
        <div className="entree-container">
            <div>
                <Link to="/Presence">
                    <img id="img-test" className="small" src={imgretour} alt="Retour" />
                </Link>
            </div>
            <h1>Sortie</h1>
            <form onSubmit={handleSubmit}>
                <label className="label-code" htmlFor="code">Veuillez saisir le code</label>
                <div className="code-inputs">
                    {code.map((char, index) => (
                        <input
                            key={index}
                            ref={el => inputRefs.current[index] = el}
                            type="text"
                            maxLength="1"
                            value={char}
                            onChange={(e) => handleChange(e.target.value, index)}
                            className="code-box"
                        />
                    ))}
                </div>
                <button type="submit" className="btn-valider">Valider</button>
                {message && <p className="message-response">{message}</p>}
            </form>
        </div>
    );
}

export default Sortie;
